import { useCallback, useEffect, useState } from "react";

import { useIsLoggedIn } from "Flocknote/stateHooks";

import { contentKeys } from "CrossFeatureComponents/MemberToolbar/contentKeys";
import { useMemberToolbarStore } from "CrossFeatureComponents/MemberToolbar/memberToolbarStore";

import {
  addUrlParam,
  getUrlParam,
  removeUrlParams,
} from "Utilities/urlParamTools";

export const useNotePopover = (isLoading, hasInitiallyLoaded) => {
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [selectedNoteId, setSelectedNoteId] = useState(null);
  const isLoggedIn = useIsLoggedIn();

  const {
    setActiveContentKey,
    setVerticallyCenterLogin,
    setCallbackAfterLogin,
  } = useMemberToolbarStore();

  const triggerLogin = useCallback(() => {
    setActiveContentKey(contentKeys.login);
    setVerticallyCenterLogin(true);
  }, [setActiveContentKey, setVerticallyCenterLogin]);

  const openPopover = useCallback(() => {
    setPopoverOpen(true);
  }, [setPopoverOpen]);

  const handleNoteClick = useCallback(
    (note) => {
      if (isLoggedIn) {
        setSelectedNoteId(note.ID);
        setPopoverOpen(true);
        addUrlParam("noteId", note.ID);
      } else {
        setSelectedNoteId(note.ID);
        setCallbackAfterLogin(openPopover);
        triggerLogin();
      }
    },
    [isLoggedIn, triggerLogin, openPopover, setCallbackAfterLogin]
  );

  const handleClosePopover = useCallback(() => {
    setPopoverOpen(false);
    // delay removing the noteId so that the iframe can animate out before unmounting
    setTimeout(() => {
      setSelectedNoteId(null);
    }, 500);
    removeUrlParams("noteId");
  }, []);

  // if noteId in URL on mount and logged in, open popover
  useEffect(() => {
    const noteIdFromUrl = getUrlParam("noteId");

    if (noteIdFromUrl && isLoggedIn) {
      setSelectedNoteId(noteIdFromUrl);
      setPopoverOpen(true);
    }
  }, [isLoggedIn]);

  // once everything is loaded check if there is a noteID and not logged in
  useEffect(() => {
    const noteIdFromUrl = getUrlParam("noteId");

    // This effect runs after all other loading is complete
    if (!isLoading && hasInitiallyLoaded && noteIdFromUrl && !isLoggedIn) {
      // Your code here - this runs after everything has loaded
      setSelectedNoteId(noteIdFromUrl);
      setCallbackAfterLogin(openPopover);
      triggerLogin();
    }
  }, [
    isLoading,
    hasInitiallyLoaded,
    triggerLogin,
    setCallbackAfterLogin,
    isLoggedIn,
    setSelectedNoteId,
    openPopover,
  ]);

  return {
    popoverOpen,
    selectedNoteId,
    handleNoteClick,
    handleClosePopover,
    triggerLogin,
  };
};
